<template>
  <div id="main-wrapper">
    <NavbarDark />

    <div class="page-title">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <h2 class="ipt-title">{{ $t('Verify Your Email') }}</h2>
          </div>
        </div>
      </div>
    </div>

    <section class="gray-simple">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-6 col-lg-7 col-md-8">
            <div class="card border-0 rounded-4 p-4">
              <div class="text-center mb-4">
                <h4>{{ $t('Enter Verification Code') }}</h4>
                <p>{{ $t('A 6-digit code was sent to your email. Please enter it below.') }}</p>
              </div>

              <form @submit.prevent="verifyEmail">
                <div class="form-group mb-3">
                  <label>{{ $t('Email') }}</label>
                  <input
                    type="email"
                    class="form-control"
                    v-model="form.email"
                  />
                  <small class="text-danger" v-if="errors.email">{{ errors.email[0] }}</small>
                </div>

                <div class="form-group mb-4">
                  <label>{{ $t('Verification Code') }}</label>
                  <input
                    type="text"
                    class="form-control text-center"
                    maxlength="6"
                    v-model="form.code"
                  />
                  <small class="text-danger" v-if="errors.code">{{ errors.code[0] }}</small>
                </div>

                <button 
                    type="submit" 
                    class="btn btn-primary full-width fw-medium"
                    :disabled="verifying"
                    >
                    <span v-if="verifying">
                        <i class="fa fa-spinner fa-spin me-2"></i> {{ $t('Verifying...') }}
                    </span>
                    <span v-else>{{ $t('Verify Email') }}</span>
                </button>
              </form>

              <div class="text-center mt-3">
                <a 
                    href="#" 
                    @click.prevent="!resending && resendCode()" 
                    :class="{ 'text-muted': resending, 'pointer-events-none': resending }"
                >
                <span v-if="resending">
                    <i class="fa fa-spinner fa-spin me-1"></i> {{ $t('Resending...') }}
                </span>
                <span v-else>{{ $t('Resend code') }}</span>
                </a>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <FooterTop :bg="'theme-bg'" />
    <FooterDark />
    <ScrollToTop />
  </div>
</template>

<script setup>
import NavbarDark from '@/components/navbar/navbar-dark.vue'
import FooterTop from '@/components/footer/footer-top.vue'
import FooterDark from '@/components/footer/footer-dark.vue'
import ScrollToTop from '@/components/scroll-to-top.vue'
import { ref } from 'vue'
import axios from 'axios'
import { useToast } from 'vue-toastification'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useRoute } from 'vue-router'

const route = useRoute()

const verifying = ref(false)  
const resending = ref(false)
const { t ,locale} = useI18n()
const toast = useToast()
const router = useRouter()

const form = ref({
  email: route.query.email || '',
  code: '',
})

const errors = ref({})

const verifyEmail = async () => {
  errors.value = {}

  if (!form.value.email || !form.value.code) {
    toast.error(t('Please fill in both fields.'))
    return
  }

  verifying.value = true 

  try {
    const res = await axios.post('/users/visitor/verify', {
      email: form.value.email,
      code: form.value.code,
    },{params:{ lang: locale.value } })
    console.log(res);
  
    toast.success(t('Your email has been verified successfully!'))
    router.push(`/${locale.value}/dashboard/${localStorage.getItem('user_id')}`)

  } catch (error) {
    const status = error.response?.status
    const responseData = error.response?.data || {}

    if (status === 422) {
      errors.value = responseData.errors || {}
      const fieldErrors = Object.values(errors.value).flat().join('\n')
      if (fieldErrors) toast.error(fieldErrors)

    } else if (status === 400) {
      toast.error(responseData.message || t('Invalid request.'))

    } else {
      toast.error(t('Something went wrong. Please try again later.'))
    }
  } finally {
    verifying.value = false 
  }
}
const resendCode = async () => {
  resending.value = true

  try {
    await axios.post('/users/visitor/register/resend', { email: form.value.email })
    toast.success(t('Verification code resent to your email.'))
  } catch (error) {
    toast.error(t('Failed to resend verification code.'))
  } finally {
    resending.value = false
  }
}
</script>
